export const EBOOK_ATTRIBUTION_COOKIE = "cc_ebook";
export const EBOOK_ATTRIBUTION_MAX_AGE_SECONDS = 60 * 60 * 24 * 180;

export interface EbookAttributionRecord {
  ebook_slug: string;
  ebook_title: string;
  ebook_funnel_role: string;
  ebook_landing_page: string;
  ebook_downloaded_at: string;
}

export interface EbookAttributionInput {
  ebookSlug: string;
  ebookTitle: string;
  ebookFunnelRole: string;
  ebookLandingPage: string;
}
